import { faker } from '@faker-js/faker/locale/en';
import { type Task } from 'features/taskboard/types/Tasks';
import { makeData } from 'mocks/helpers';
import { taskNotes } from './taskNote';
import { taskUsers } from './taskUser';
import { loggedInUser } from 'mocks/data/user';
import { checkModule, checkRole } from 'features/accessControl/utils';
export const newTask = (identifyer: number): Task => {
  // faker.seed with a consistent number will always generate the same data
  //faker.seed(identifyer);
  const isComplianceModuleActive =
    checkModule(workflowTaskEntityType[3], loggedInUser?.Organization.Modules) &&
    (checkRole('Compliance Admin', loggedInUser?.RoleNames) ||
      checkRole('Compliance User', loggedInUser?.RoleNames));
  const taskId = faker.number.int();
  const designerOrganizationId = faker.number.int();
  const entityTypes = [
    workflowTaskEntityType[0],
    workflowTaskEntityType[1],
    workflowTaskEntityType[2],
  ];
  if (isComplianceModuleActive) {
    entityTypes.push(workflowTaskEntityType[3]);
  }
  const taskEntityType = faker.helpers.arrayElement(entityTypes);
  /* const sampleRequestState = faker.helpers.arrayElement([
    sampleRequestStates.Requested,
    sampleRequestStates.Sent,
    sampleRequestStates.Received,
    sampleRequestStates.Commented,
    sampleRequestStates.Cancelled,
    sampleRequestStates.Confirmed,
    sampleRequestStates.Planned,
  ]);
  const state =
    taskEntityType === taskEntityTypes.Sampling
      ? sampleRequestState
      : faker.helpers.arrayElement([
          taskStates.ToDo,
          taskStates.InProgress,
          taskStates.Stuck,
          taskStates.Done,
        ]); */
  const state = faker.helpers.arrayElement([1, 2, 3, 4]);
  const assignedToPerson = faker.helpers.arrayElement(taskUsers);
  const viewedOn = faker.helpers.arrayElement([
    faker.date.recent(),
    faker.date.recent(),
    faker.date.recent(),
    null,
  ]);
  if (viewedOn === null) {
    assignedToPerson.id = loggedInUser.Id;
  }
  const entityType = faker.number.int({ min: 0, max: 3 });
  return {
    id: taskId,
    taskName: faker.company.catchPhrase(),
    entityType,
    viewedOn,
    certificateId: faker.number.int(),
    adminWorkflow: {
      id: faker.number.int(),
      name: faker.company.name(),
      organizationId: designerOrganizationId,
      position: faker.number.int(),
      colorCode: faker.internet.color(),
    },
    assignedToPerson,
    taskState: state,
    deadline: taskEntityType === workflowTaskEntityType[2] ? null : faker.date.future(),
    assignedTo: assignedToPerson.organizationTypeId === 1 ? '1' : '2',
    toDoBy: faker.helpers.arrayElement(taskUsers),
    inProgressBy: faker.helpers.arrayElement(taskUsers),
    doneBy: faker.helpers.arrayElement(taskUsers),
    assignedBy: faker.helpers.arrayElement(taskUsers),
    doneDate: faker.date.recent().toDateString(),
    lastUpdatedDate: faker.date.recent().toDateString(),
    lastUpdatedBy: faker.helpers.arrayElement(taskUsers),
    priority: faker.helpers.arrayElement([1, 2, 3]),
    organizationId: faker.number.int(),
    ...(entityType === 0
      ? {}
      : {
          imageUrl:
            taskEntityType === workflowTaskEntityType[1] ||
            taskEntityType === workflowTaskEntityType[2]
              ? faker.image.urlPicsumPhotos()
              : '',
          taskboardBrand: {
            id: faker.number.int(),
            name: faker.lorem.word(5),
          },
          taskboardCategory: faker.lorem.word(5),
          taskboardSupplier: {
            id: faker.number.int(),
            name: faker.lorem.word(5),
          },
          taskboardSeason: {
            id: faker.number.int(),
            name: faker.lorem.word(5),
          },
          linkedTo: {
            fieldData:
              taskEntityType === workflowTaskEntityType[0]
                ? { id: 0, name: '' }
                : {
                    id: faker.number.int(),
                    name: faker.commerce.productName(),
                  },
            userDefinedId: faker.number.int().toString(),
          },
        }),
    ...(entityType === 1 ? { styleId: faker.number.int() } : {}),
    ...(entityType === 2 ? { itemId: faker.number.int() } : {}),
    notes: [...taskNotes(taskId)],
    deletedBy: null,
    deletedOn: null,
    styleGroup:
      taskEntityType === workflowTaskEntityType[1]
        ? {
            id: faker.number.int(),
            name: faker.lorem.word(5),
          }
        : null,
    certificateState:
      taskEntityType === workflowTaskEntityType[3]
        ? faker.helpers.arrayElement([
            certificateStates['-1'],
            certificateStates[0],
            certificateStates[1],
            certificateStates[2],
            certificateStates[3],
            certificateStates[4],
            certificateStates[5],
          ])
        : '',
    certificateInstitute:
      taskEntityType === workflowTaskEntityType[3]
        ? {
            id: faker.number.int(),
            name: faker.lorem.word(5),
          }
        : null,
    certificateValidFrom: taskEntityType === workflowTaskEntityType[3] ? faker.date.recent() : null,
    certificateValidTo: taskEntityType === workflowTaskEntityType[3] ? faker.date.future() : null,
    certificateType:
      taskEntityType === workflowTaskEntityType[3]
        ? faker.helpers.arrayElement([
            certificateTypes[1],
            certificateTypes[2],
            certificateTypes[3],
            certificateTypes[4],
          ])
        : null,
    styleHeaderCustomField:
      taskEntityType === workflowTaskEntityType[1]
        ? {
            id: faker.number.int(),
            customFieldName: faker.lorem.word(5),
            customFieldValue: faker.lorem.word(5),
          }
        : null,
    createdDate: faker.date.recent(),
    isTaskUnread: faker.datatype.boolean(),
  } as unknown as Task;
};

export const taskStates = {
  //'-1': 'None',
  0: 'To Do',
  1: 'In Progress',
  2: 'Done',
  3: 'Stuck',
};

export const workflowTaskEntityType = {
  0: 'Free',
  1: 'Style',
  2: 'Item',
  3: 'Certificate',
};

export const sampleRequestStates = {
  Requested: 'Requested',
  Sent: 'Sent',
  Received: 'Received',
  Commented: 'Commented',
  Cancelled: 'Cancelled',
  Confirmed: 'Confirmed',
  Planned: 'Planned',
};

export const certificateStates = {
  '-1': 'None',
  0: 'Draft',
  1: 'In progress',
  2: 'Valid',
  3: 'Expired',
  4: 'Cancelled',
  5: 'Passed',
  6: 'Failed',
};

export const certificateTypes = {
  1: 'Product',
  2: 'Scope',
  3: 'Test Report',
  4: 'Transaction',
};

export const taskPriority = {
  1: 'Low',
  2: 'Medium',
  3: 'High',
};

export const assignedTo = {
  '-1': 'All',
  0: 'None',
  1: 'CompanyPerson',
  2: 'Brand Contact',
  3: 'Supplier Contact',
  4: 'SupplierCompanyPerson',
};

/**
 * Deterministic rows for DL-62378 (Taskboard search across visible grid columns, Testmo
 * #1808680). Each row carries one unique, distinguishing value for the grid column its
 * name calls out, so an e2e spec can type that value and assert exactly one matching row
 * comes back from the mocked `GET /api/tasks?search=...`. Built from `newTask()` (not
 * hand-rolled) so every other required `Task` field stays realistic, then the target
 * field is overridden. Kept out of `taskUsers`/random pools so the value can't
 * coincidentally collide with faker-generated noise across the other 101 rows.
 *
 * `assignedTo: '1'` is forced on every row (not just the Assignee fixture): `useTaskList`
 * (`features/taskboard/api/getTasks.tsx`) always sends an `assignedTo` param (defaulted from the
 * logged-in user's org type when not explicitly set), and the handler's `applyTaskFilters`
 * (`taskHelpers.ts`) unconditionally filters on it whenever it's `'1'` or `'2'` — so a fixture
 * row built from `newTask()`'s randomized `assignedTo` ('1' or '2' with even odds per call) would
 * intermittently get silently dropped from *every* search result, independent of whether the
 * search term itself matched. Pinning it to `'1'` (matching the demo designer user's default)
 * keeps these rows deterministically visible.
 */
const withDefaultAssignee = (overrides: Partial<Task>): Task => ({
  ...newTask(overrides.id as number),
  assignedTo: '1',
  ...overrides,
});

export const searchFixtureTasks: Task[] = [
  withDefaultAssignee({
    id: 900001,
    taskName: 'Zephyr Ridge Expedition Parka QA Review',
  }),
  withDefaultAssignee({
    id: 900002,
    // entityType 1 (Style) so LinkedToCell's Chip (gated on entityType !== 0) actually
    // renders this row's linkedTo.fieldData.name instead of the "no link" state.
    entityType: 1,
    styleId: 900002,
    linkedTo: {
      fieldData: { id: 900002, name: 'Glacier Peak Storm Shell' },
      userDefinedId: '900002',
    },
  }),
  withDefaultAssignee({
    id: 900003,
    linkedTo: {
      fieldData: { id: 900003, name: 'Boreal Trail Runner' },
      userDefinedId: 'NUM-778899-ZQ',
    },
  }),
  withDefaultAssignee({
    id: 900004,
    taskboardBrand: { id: 900004, name: 'Nordkapp Outdoors Collective' },
  }),
  withDefaultAssignee({
    id: 900005,
    taskboardSeason: { id: 900005, name: 'Aurora Winter Twentyseven' },
  }),
  withDefaultAssignee({
    id: 900006,
    taskboardSupplier: { id: 900006, name: 'Fjordline Textile Mill' },
  }),
  withDefaultAssignee({
    id: 900007,
    // getAssigneeName() (utils/index.ts) renders the "Brand Contact" / "Supplier Contact"
    // constant instead of assignedToPerson.name for assignedTo '2' / '3' — assignedTo '1' above
    // is also what keeps this row's own distinguishing name on display.
    assignedToPerson: {
      ...taskUsers[0],
      name: 'Ingrid Vindstrøm',
    },
  }),
  withDefaultAssignee({
    id: 900008,
    taskboardCategory: 'Sustainability Compliance Review',
  }),
];

export const tasks = [...searchFixtureTasks, ...makeData(101, newTask)];

const taskLink = () => ({
  entityId: faker.number.int(),
  entityNumber: faker.number.int().toString(),
  entityName: faker.commerce.productName(),
  entityType: faker.helpers.arrayElement(['Style', 'Item']),
  entityInfo: {
    season: faker.lorem.word(5),
    brand: faker.lorem.word(5),
    supplier: faker.lorem.word(5),
    certificateType: faker.lorem.word(5),
    imageUrl: faker.image.urlPicsumPhotos(),
  },
});

export const taskLinks = makeData(10, taskLink);
